import { jsonPostV2, handleJsonPostError } from "./apiUtils";
import _ from "lodash";

export const ROUTE_HISTORY = "ROUTE_HISTORY";
export const CONSOLIDATED_HISTORY = "CONSOLIDATED_HISTORY";
export const ROUTE_HISTORY_TOGGLE = "ROUTE_HISTORY_TOGGLE";
export const FETCHING_HISTORY = "FETCHING_HISTORY";
export const SHOW_ROUTE_HISTORY = "SHOW_ROUTE_HISTORY";
export const CLEAR_ROUTE_HISTORY = "CLEAR_ROUTE_HISTORY";

export function consolidatedHistory(key, success, history, years, routePosition, qa) {
    return {
        type: CONSOLIDATED_HISTORY,
        key,
        success,
        history,
        years,
        routePosition,
        qa,
    };
}

export function routeHistory(key, success, history) {
    return {
        type: ROUTE_HISTORY,
        key,
        success,
        history,
    };
}

export function setRouteHistoryHidden(hidden) {
    return {
        type: ROUTE_HISTORY_TOGGLE,
        hidden,
    };
}

export const setFetchingHistory = (fetchingTimestamp, fetchingYear) => {
    return {
        type: FETCHING_HISTORY,
        fetchingTimestamp,
        fetchingYear,
    };
};

export const toggleShowHistory = (show) => {
    return {
        type: SHOW_ROUTE_HISTORY,
        show,
    };
};

export function consolidatedRouteVideoLookup(route_location, callback) {
    return {
        queue: CONSOLIDATED_HISTORY,
        callback: (next, dispatch, getState) => {
            let postBody = {
                action: "consolidated_history",
                system_id: route_location.system,
                route_id: route_location.route,
                route_position: route_location.position,
                route_subposition: route_location.subposition,
            };
            let url = "/route";
            jsonPostV2(url, getState(), postBody, dispatch)
                .then((response) => {
                    const most_recent = _.chain(response).filter({ sub_position: route_location.subposition }).maxBy("timestamp").value();
                    callback(most_recent === undefined, most_recent);
                })
                .catch((error) => {
                    handleJsonPostError("Error finding consolidated route history", "An error occurred while searching consolidated route history", error);
                    callback(error);
                });
            next();
        },
    };
}

let routeHistoryRequests = [];

export function getPagedRouteHistory(routeLocation, sameTrackOnly, qaFiltered, timestampFilter) {
    return (dispatch, getState) => {
        const state = getState();
        const fetchingPosition = state.playlist.consolidatedHistory.fetching;
        const fetchedPosition = state.playlist.consolidatedHistory.requestedPosition;
        const qaFetched = state.playlist.consolidatedHistory.qaFetched;

        const fetchedYears = state.playlist.consolidatedHistory.requestedYears;
        const fetchingYears = state.playlist.consolidatedHistory.fetchingYear;

        const routePosition = routeLocation.position.toFixed(3);

        if (
            (fetchingPosition === routePosition || fetchedPosition === routePosition) &&
            (fetchedYears === timestampFilter || fetchingYears === timestampFilter) &&
            qaFiltered === qaFetched
        ) {
            return;
        }

        routeHistoryRequests.forEach((historyRequest) => {
            historyRequest.abort("user_abort");
        });

        const YEAR_SECONDS = 60 * 60 * 24 * 365;
        let startTs = Date.now() / 1000 - YEAR_SECONDS;
        let endTs = Date.now() / 1000;
        if (timestampFilter !== -1) {
            const currentYear = new Date().getFullYear();
            const endOfYear = new Date(currentYear, 11, 31);
            const endOfYearTimestamp = endOfYear.getTime() / 1000;

            endTs = endOfYearTimestamp - timestampFilter * YEAR_SECONDS;
            startTs = endTs - YEAR_SECONDS;
        }

        routeHistoryRequests = [];
        const REQUESTS_TO_SEND = 1;
        const INTERVAL_SECONDS = (endTs - startTs) / REQUESTS_TO_SEND;
        startTs = endTs - INTERVAL_SECONDS;

        dispatch(setFetchingHistory(routePosition, timestampFilter));
        let first = true;
        for (let i = 0; i < REQUESTS_TO_SEND; i++) {
            if (startTs < Date.now() / 1000) {
                dispatch(consolidatedHistoryLookup(routeLocation, sameTrackOnly, qaFiltered, startTs, endTs, first, timestampFilter));
                first = false;
            }
            endTs = startTs;
            startTs = endTs - INTERVAL_SECONDS;
        }
    };
}

export function consolidatedHistoryLookup(route_location, same_track_only, qaFiltered, startTs = null, endTs = null, first = false, yearsAgo) {
    const routePosition = route_location.position.toFixed(3);
    return (dispatch, getState) => {
        let postBody = {
            action: "consolidated_history",
            system_id: route_location.system,
            route_id: route_location.route,
            route_position: routePosition,
            qa_filtered: qaFiltered,
            start_ts: startTs,
            end_ts: endTs,
        };
        if (same_track_only && route_location.subposition !== null) {
            postBody.route_subposition = route_location.subposition;
        }
        let url = "/route";
        const abortController = new AbortController();
        routeHistoryRequests.push(abortController);
        return jsonPostV2(url, getState(), postBody, dispatch, false, abortController.signal)
            .then((response) => {
                const state = getState();
                const fetchingPosition = state.playlist.consolidatedHistory.fetching;
                const fetchedPosition = state.playlist.consolidatedHistory.requestedPosition;

                const sessionConfig = state.userDetails.sessionConfig;
                const forceFilters = _.get(sessionConfig, ["force_filters"], false);
                let filteredHistory = response;
                if (forceFilters) {
                    const sessionIds = state.sessionList;
                    filteredHistory = response.filter((historyItem) => {
                        return sessionIds.includes(historyItem.session_id);
                    });
                }

                if (routePosition === fetchingPosition || routePosition === fetchedPosition) {
                    dispatch({
                        type: CLEAR_ROUTE_HISTORY,
                    });

                    dispatch(consolidatedHistory(routePosition, true, filteredHistory, yearsAgo, routePosition, qaFiltered));
                }
                if (first) {
                    dispatch(setFetchingHistory(false));
                }
            })
            .catch((error) => {
                if (error !== "user_abort") {
                    handleJsonPostError("Error finding consolidated route history", "An error occurred while searching consolidated route history", error);
                    dispatch(consolidatedHistory(routePosition, false, []));
                }
            });
    };
}
